import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import MainLayout from './components/MainLayout';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import ContactPage from './pages/ContactPage';
import ProjectsPage from './pages/ProjectsPage';
import DesignIdeasPage from './pages/DesignIdeasPage';
import CitiesPage from './pages/CitiesPage';
import BlogPage from './pages/BlogPage';
import BlogDetailPage from './pages/BlogDetailPage';

// Admin Imports
import { AuthProvider } from './admin/AuthContext';
import PrivateRoute from './admin/PrivateRoute';
import AdminLayout from './admin/AdminLayout';
import LoginPage from './admin/LoginPage';
import Dashboard from './admin/Dashboard';
import MessagesList from './admin/MessagesList';
import BlogManager from './admin/BlogManager';
import ProjectManager from './admin/ProjectManager';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <AuthProvider>
      <ScrollToTop />
      <Routes>
        {/* Frontend Routes */}
        <Route element={<MainLayout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/design-ideas" element={<DesignIdeasPage />} />
          <Route path="/cities" element={<CitiesPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogDetailPage />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Route>

        {/* Admin Routes */}
        <Route path="/admin/login" element={<LoginPage />} />
        <Route path="/admin" element={<PrivateRoute />}>
          <Route element={<AdminLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="messages" element={<MessagesList />} />
            <Route path="blogs" element={<BlogManager />} />
            <Route path="projects" element={<ProjectManager />} />
          </Route>
        </Route>

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;
